import { useEffect, useRef } from "react";

const ScrollProgress = () => {
  const fillRef = useRef(null);

  useEffect(() => {
    let animationFrame = null;

    const updateProgress = () => {
      animationFrame = null;
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollableHeight > 0 ? Math.min(window.scrollY / scrollableHeight, 1) : 0;

      if (fillRef.current) fillRef.current.style.transform = `scaleX(${progress})`;
    };

    const requestUpdate = () => {
      if (animationFrame === null) animationFrame = requestAnimationFrame(updateProgress);
    };

    requestUpdate();
    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate);

    return () => {
      window.removeEventListener("scroll", requestUpdate);
      window.removeEventListener("resize", requestUpdate);
      if (animationFrame !== null) cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div className="scroll-progress" aria-hidden="true">
      <span ref={fillRef} className="scroll-progress__fill" />
    </div>
  );
};

export default ScrollProgress;
